import { format } from "date-fns";
import { ru, enUS } from "date-fns/locale";
import type { AdaptiveDateProps } from "../types/recordHeader.types";
import { useTranslation } from "react-i18next";

export const AdaptiveDate = ({ date, className = "" }: AdaptiveDateProps) => {
  const { i18n } = useTranslation();

  const formatDate = (dateString: string, formatString: string) => {
    try {
      const locale = i18n.language === 'en' ? enUS : ru;
      return format(new Date(dateString), formatString, { locale });
    } catch (e) {
      return dateString;
    }
  };

  const mobileFormat = formatDate(date, "dd MMM, HH:mm");
  const desktopFormat = formatDate(date, "dd MMMM yyyy, HH:mm");

  return (
    <div className={className}>
      <div className="text-[11px] text-muted-foreground font-medium sm:hidden">
        {mobileFormat}
      </div>
      <div className="text-xs text-muted-foreground hidden sm:block">
        {desktopFormat}
      </div>
    </div>
  );
};